<script>
    import { push } from 'svelte-spa-router'
    import Hamburger from '../menu.svelte'
    import Map from '@anoram/leaflet-svelte'

    import { fly } from 'svelte/transition'

    // npm から取ってくる
    import { onMount, onDestroy } from 'svelte';
    // この component（ Numbers.svelte ）が消えても　最後の y値 が消えないように stores 保存 
    import { y_last } from "../stores1"

    let y_value;

    // この component（ Numbers.svelte ）が消えるときに発動
    onDestroy(() => {
        // 最後の y値 を保存
        y_last.set(y_value)
    })

    // この component が現れるときに発動
    onMount(() => {
        // y値 を 最後の y値（= $y_last）と同じにする
        y_value = $y_last
    })

    var menu_counter = 0
        let menu_status = "off"

    const hamburger = () => {
        menu_counter++
        if (menu_counter % 1) {
            menu_status = "on"
        } else {
            menu_status = "off"
        }
    }

    let options={
        center: [35.69242304791793, 139.60488822706014],
        zoom:14.5,
        maxZoom:17,
        markers: [
            {
                lat: 35.69242304791793,
                lng: 139.60488822706014,
            },
            {
                lat:35.68816838851287,
                lng:139.59930263599136,
                tooltip:{
                    inOpen:true,
                    text:`久我山駅`,
                    direction:"top",
                    permanent:'true',
                },
            },
        ],
        mapID: "map",
    };

    import Policy from '../policy.svelte'
    import { policy } from '../stores6'

    const openPolicy = () => {
        policy.set(true)
    }

    import { nightmode } from "../stores5"
</script>

<div class:night={$nightmode} style="padding-left:8px;">
    <header class="header" transition:fly="{{x: 200}}">
        <div class="header-space1"></div>
        <div class="header-title" on:click={() => push('/base1')}>第75回記念祭</div>
        <div class="header-space2"></div>
    </header>
    <div class="catch">
        <div class="catch-item1" transition:fly="{{x: 200}}"></div>
        <div class="catch-item2" class:catch-item2-night={$nightmode} transition:fly="{{x: -200}}">アクセス</div>
    </div>
    <div class="attention" class:attention-night={$nightmode} transition:fly="{{x: -200}}">
        <p class="attention-item">駐車場はありません<br>公共交通機関/自転車をご利用ください</p>
    </div>
    <div class="train-bus" transition:fly="{{x: -200}}">
        <div class="train-bus-item"> 
            <div class="train-bus-item-title" class:train-bus-item-title-night={$nightmode}>電車/バスをご利用の場合</div>
            <div class="train-bus-item-station">久我山駅（京王井の頭線）</div>
            <ul>
                <li>徒歩10分</li>
            </ul>
            <div class="train-bus-item-station">荻窪駅（JR中央線/JR中央・総武線/東京メトロ丸の内線）</div>
            <ul>
                <li>
                    <p>荻60系統　荻窪駅南口発宮前3丁目行</p>
                    <p>宮前3丁目　下車</p>
                </li>
            </ul>
            <div class="train-bus-item-station">西荻窪駅（JR中央線/JR中央・総武線）</div>
                <ul>
                    <li>
                        <p>すぎ丸かえで路線　西荻窪駅発久我山駅行</p>
                        <p>西高校西門前　下車</p>
                    </li>
                </ul>
            <div class="train-bus-item-station">中野駅（JR中央線/JR中央・総武線/東京メトロ東西線）</div>
                <ul>
                    <li>
                        <p>中36系統　中野駅発吉祥寺駅北口行</p>
                        <p>宮前4丁目　下車</p>
                    </li>
                </ul>
            <div class="train-bus-item-station">吉祥寺駅（JR中央線/JR中央・総武線/京王井の頭線）</div>
                <ul>
                    <li>
                        <p>中36系統　吉祥寺駅北口発中野駅行</p>
                        <p>宮前4丁目　下車</p>
                    </li>
                </ul>
        </div>
    </div>
    <!--<div class="map" transition:fly="{{x: -200}}">
        <div class="map-title" class:map-title-night={$nightmode}>地図</div>
        <div class="leaflet-map">
            <Map {options} />
        </div>
    </div>-->
    <footer class="footer" transition:fly="{{x: -200}}">
        <div class="footer-title" on:click={() => push('/base1')}>第75回記念祭</div>
        <div class="policy" on:click={openPolicy}>プライバシーポリシー</div>
        <div class="footer-copyright">Copyright © 第75回記念祭 All Rights Reserved</div>
    </footer>
</div>

{#if menu_counter % 2 === 1}
<Hamburger/>
{/if}

{#if $policy}
<Policy/>
{/if}

<svelte:window bind:scrollY={y_value}/>

<style>
.night{
    background-color: #222831;
    color:#DDDDDD;
}
.header{
    display:flex;
    flex-wrap: wrap;
    width:100%;
}
.header-space1{
    flex-basis:44%;
}
.header-title{
    font-size:24px;
    font-weight: 400;
    text-align: right;
    letter-spacing: 5px;
    margin-top:12px;
    margin-bottom:12px;
    flex-basis:50%;
    font-family: 'Noto Sans JP';
    cursor: pointer;
}
.header-space2{
    flex-basis:6%;
}
.catch{
    position:relative;
    width:100%;
    height:580px;
    overflow: hidden;
}
.catch-item1{
    position:absolute;
    top:20px;
    right:-15px;
    width:80%;
    height:500px;
    background-image: url(/img/suginami.png);
    background-size: cover;
    background-repeat: no-repeat;
    background-position: 70% 50%;
    filter: saturate(0%);
    border-radius: 20px;
}
.catch-item2{
    display:table;
    background-color: greenyellow;
    position:absolute;
    top:500px;
    left:2%;
    font-size:40px;
    letter-spacing:.05em;
}
.catch-item2-night{
    color:#222831;
}
.attention{
    margin:20px 0 20px 2%;
    padding-left:10px;
    width:85%;
    border-left: solid 6px greenyellow;
}
.attention-item{
    font-size:20px;
    line-height: 1.2em;
}
.train-bus{
    width:85%;
    margin-left:2%;
    padding:30px 0;
    border-bottom: 1px solid;
}
.train-bus-item-title{
    display:table;
    font-size:24px;
    margin-bottom:20px;
    background-color:greenyellow;
}
.train-bus-item-title-night{
    color:#222831;
}
.train-bus-item ul{
    padding-left:4px;
}
.train-bus-item li{
    line-height: 1.5em;
    font-size:16px;
    list-style-type: none;
    margin:20px 0 40px 0;
    padding-left:10px;
    border-left: solid 6px rgb(160, 160, 160);
}
.train-bus-item ul li p{
    margin:5px 0 5px 0;
    line-height: 1.5em;
}
.train-bus-item-station{
    font-size: 20px;
    line-height: 1.2em;
}
.map{
    width:85%;
    margin-left:2%;
    padding:30px 0;
    border-bottom:solid 1px;
}
.map-title{
    display:table;
    font-size:24px;
    margin-bottom:20px;
    background-color:greenyellow;
}
.map-title-night{
    color:#222831;
}
.leaflet-map{
    width:100%;
    height:300px;
}
.footer{
    padding:40px 10px 40px 2%;
}
.footer-title{
    text-align: left;
    font-size:26px;
    font-weight:300;
    cursor: pointer;
}
.footer-copyright{
    text-align: left;
    font-size: 14px;
    font-weight: 300;
    margin:10px 0 0 0;
}
.policy{
    text-align: left;
    font-size: 14px;
    font-weight: 300;
    margin:10px 0 0 0;
    cursor: pointer;
}
</style>